/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 清除项目缓存预热相关缓存
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  productId: number,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "delete",
    url: `/good/product/pre-cache/${productId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
